export const B2_WORKER_BASE_URL = import.meta.env.VITE_B2_WORKER_URL!;

export function workerUrl(key: string) {
  return `${B2_WORKER_BASE_URL}/${encodeURIComponent(key)}`;
}
